import { render, staticRenderFns } from "./ProgramHeader.vue?vue&type=template&id=58cac533&scoped=true&"
import script from "./ProgramHeader.vue?vue&type=script&lang=js&"
export * from "./ProgramHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProgramHeader.vue?vue&type=style&index=0&id=58cac533&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cac533",
  null
  
)

export default component.exports